import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({
  baseURL: API,
  timeout: 90000,
});

export async function trackPortal(reference, plz) {
  const { data } = await api.post(`/track-portal`, {
    reference: reference.trim(),
    plz: plz.trim(),
  });
  return data;
}

export async function trackShipment(reference) {
  const ref = encodeURIComponent(reference.trim());
  const { data } = await api.get(`/track/${ref}`);
  return data;
}

export async function seedDemo() {
  const { data } = await api.post(`/demo/seed`);
  return data;
}
